import axios from "@/axios";
import apiUrl from "@/axios/config";
const funds = {
  /**
   * ========================================================
   * ************   注资   ************
   * ========================================================
   */

  //模拟客户注资页面信息 /uc/simulator/depositInfo
  async getDepositInfo(params = "") {
    return await axios.post("/uc/simulator/depositInfo", params, {
      des: "直客pc模拟客户注资页面信息",
      sTime: new Date().getTime()
    });
  },
  //模拟客户注资页面信息 /uc/simulator/deposit
  async simDeposit(params = "") {
    return await axios.post("/uc/simulator/deposit", params, {
      des: "直客pc模拟客户注资页面信息",
      sTime: new Date().getTime()
    });
  },
  // 获取汇率
  async getRate(params = "") {
    return await axios.post("/uc/deposit/rate", params, {
      des: "直客pc获取汇率",
      sTime: new Date().getTime()
    });
  },
  //银行汇款汇率查询
  getBankRate(params = "") {
    return axios.post("/uc/deposit/getRate", params, {
      des: "直客pc银行汇款汇率查询",
      sTime: new Date().getTime()
    });
  },
  //获取提现界面信息
  async getApplyGold(params = "") {
    return await axios.post("/uc/gold/applyGold", params, {
      des: "直客pc获取提现界面信息",
      sTime: new Date().getTime()
    });
  },
  //提交银行汇款通知单
  async subApplyGold(params) {
    return await axios.post("/uc/deposit/bank/add", params, {
      des: "直客pc提交银行汇款通知单",
      sTime: new Date().getTime()
    });
  },
  // 获取支持银行
  async getPaymentList(params = "") {
    return await axios.post("/uc/deposit/web/deposit/banks", params, {
      des: "直客pc获取支持银行",
      sTime: new Date().getTime()
    });
  },
  // 获取手机验证码
  async getMobileCode(params = "") {
    return await axios.post("/uc/deposit/web/deposit/shortcut/code", params, {
      des: "直客pc获取手机验证码",
      sTime: new Date().getTime()
    });
  },
  // 快捷支付确认支付
  async quickPay(params = "") {
    return await axios.post("/uc/deposit/web/deposit/shortcut", params, {
      des: "直客pc快捷支付确认支付",
      sTime: new Date().getTime()
    });
  },
  //获取商城支付跳转链接
  async getShopLink(params) {
    return await axios.post("/uc/gold/rechargeBuyMallUrl", params, {
      des: "直客pc获取商城支付跳转链接",
      sTime: new Date().getTime()
    });
  },
  //获取通道列表
  async getPayAggregatedList(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/getPayAggregatedList",
      params,
      { des: "直客pc获取通道列表", sTime: new Date().getTime() }
    );
  },
  //提交注资跳转
  async submitDeposit(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/createAggregatedOrder",
      params,
      { des: "直客p提交注资跳转", sTime: new Date().getTime() }
    );
  },
  //获取快捷支付跳转链接
  async AntPurseLink(params = "") {
    return await axios.post(
      "/uc/deposit/web/deposit/antWalletQuickLogin",
      params,
      { des: "直客pc获取快捷支付跳转链接", sTime: new Date().getTime() }
    );
  },
  //网上充值
  async createEpupayOrder(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/createEpupayOrder",
      params,
      { des: "直客pc网上充值", sTime: new Date().getTime() }
    );
  },

  //蚂蚁钱包短链接
  async GetDeCodeUrlBaseString(params) {
    return await axios.post("/api/UrlCode/GetDeCodeUrlAddress", params, {
      baseUrl: apiUrl.API_BASE_ANT,
      des: "直客pc快捷支付",
      sTime: new Date().getTime()
    });
  },

  // 验证资金权限  接口已废弃
  // async checkGoldPageList(params) {
  //   return await axios.post('/uc/goldPage/jfGoldPageStatus', params, { des: '直客pc验证资金权限', sTime: new Date().getTime() })
  // },

  /**
   * ========================================================
   * ************   提现   ************
   * ========================================================
   */

  // 获取用户信息判断是否绑定手机、IDCard
  async getIdentityInfo(params = "") {
    return await axios.post("/uc/gold/isAuthentication", params, {
      des: "直客pc获取用户信息判断是否绑定手机、IDCard",
      sTime: new Date().getTime()
    });
  },
  // 获取提现界面的信息
  async getApplyGoldInfo(params = "") {
    return await axios.post("/uc/gold/applyGold", params, {
      des: "直客pc获取提现界面的信息",
      sTime: new Date().getTime()
    });
  },
  // 选择银行列表
  async getChoiceBankList(params = "") {
    return await axios.post("/uc/gold/choiceBankList", params, {
      des: "直客pc选择银行列表",
      sTime: new Date().getTime()
    });
  },
  // 出金手续费确认
  async poundageConfirm(params = "") {
    return await axios.post("/uc/gold/poundageConfirm", params, {
      des: "直客pc出金手续费确认",
      sTime: new Date().getTime()
    });
  },
  // 获取验证码
  async getCode(params = "") {
    return await axios.post("/uc/sendcode2", params, {
      des: "直客pc获取验证码",
      sTime: new Date().getTime()
    });
  },
  // 提现提交
  async submitGold(params = "") {
    return await axios.post("/uc/gold/submitGold", params, {
      des: "直客pc提现提交",
      sTime: new Date().getTime()
    });
  },

  /**
   * ========================================================
   * ************   资金明细   ************
   * ========================================================
   */

  // 注资记录查询
  async getDepositDetails(params = "") {
    return await axios.post("/uc/deposit/query", params, {
      des: "直客pc注资记录查询",
      sTime: new Date().getTime()
    });
  },
  // 出金记录查询
  async getWithdrawDetails(params = "") {
    return await axios.post("/uc/gold/list", params, {
      des: "直客pc出金记录查询",
      sTime: new Date().getTime()
    });
  },
  // 取消出金
  async giveUp(params = "") {
    return await axios.post("/uc/gold/giveup", params, {
      des: "直客pc取消出金",
      sTime: new Date().getTime()
    });
  },
  // 获取银行详细
  async getBackDetails(params = "") {
    return await axios.post("/uc/user/bank/detail", params, {
      des: "直客pc获取银行详细",
      sTime: new Date().getTime()
    });
  },
  // 提示
  async isNeedDeductGold(params = "") {
    return await axios.post("/uc/gold/isNeedDeductGold", params, {
      des: "直客pc提示",
      sTime: new Date().getTime()
    });
  },
  //获取转账支付注资金额
  async getArtificialCardType(params = "") {
    return await axios.post(
      "/uc/deposit/web/deposit/getArtificialCardType",
      params,
      { des: "直客pc获取转账支付注资金额", sTime: new Date().getTime() }
    );
  },
  //提交转账支付
  async createArtificialPayOrder(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/createArtificialPayOrder",
      params,
      { des: "直客pc提交转账支付", sTime: new Date().getTime() }
    );
  },
  //根据订单号获取url
  async getArtificialPayUrl(params) {
    return await axios.post(
      "/uc/deposit/web/deposit/getArtificialPayUrl",
      params,
      { des: "直客pc根据订单号获取url", sTime: new Date().getTime() }
    );
  },
  //用户中心-入金方式列表
  async getAllQuickPaymentType(params) {
    return await axios.post("/uc/payMode/GetAllQuickPaymentType", params);
  },
  //用户中心-入金方式列表-创建订单
  async quickCreateOrder(params) {
    return await axios.post("/uc/payMode/QuickCreateOrder", params, {
      async: false
    });
  },
  //用户中心-入金方式列表第二种-创建订单
  async quickCreateOrder2(params) {
    return await axios.post("/uc/payMode/QuickCreateOrder2", params, {
      uuid: true
    });
  },
  //用户中心-入金方式列表-取消订单
  async userUpdateCancelOrder(params) {
    return await axios.post("/uc/payMode/UserUpdateCancelOrder", params);
  },
  //用户中心-入金方式列表-确认付款(只针对蚂蚁钱包)
  async confirmationPayment(params) {
    return await axios.post("/uc/payMode/ConfirmationPayment", params);
  },
  //用户中心-入金方式列表-获取订单详情
  async getOrderDetail(params) {
    return await axios.post("/uc/payMode/GetOrderDetail", params);
  },
  //用户中心-资金管理- 入金页面显示    接口已废弃
  // jfdepositPage(params) {
  //   let data;
  //   axios.post('/uc/goldPage/jfdepositPage', params, {
  //     async: false,
  //     success: function(res) {
  //       data = res;
  //     }
  //   })
  //   return data;
  // },
  async isShow(params) {
    return await axios.post("uc/firstChargeActivity/isShow", params);
  },
  //用户中心，获取用户认证绑定信息
  async getidentityInfoPc(params) {
    return await axios.post("uc/user/userinfo/identityInfoPc", params);
  },
  //获取出金时手续费比例
  async getServiceCharge(params) {
    return await axios.get("uc/gold/getServiceCharge", params, {
      des: "获取出金时手续费比例",
      sTime: new Date().getTime()
    });
  },

  //获取提现方式等信息
  async getWithdrawMode(params) {
    return await axios.get("uc/gold/qrcode", params, {
      des: "获取提现方式等信息",
      sTime: new Date().getTime()
    });

    return new Promise((res, rej) => {
      res({
        Status: "0",
        IsSuccess: true,
        Data: {
          mjActualMoney: 2898.9,
          rmbActualMoney: 21232.16,
          rmbActualRoundMoney: 21232.0,
          banks: [],
          receiptModeList: {
            "1": "银行卡取款",
            "2": "数字钱包取款"
          },
          poundage: 322.1,
          mjMoney: 3221.0,
          isSmallWithdrawal: "0"
        },
        Token: ""
      });
    });
  },
  //获取OSS参数信息
  async getendpoint(params) {
    return await axios.get("common/getendpoint", params, {
      des: "获取OSS参数信息",
      sTime: new Date().getTime()
    });
  },
  //获取OSS验证签名
  async getCallbackSign(params) {
    return await axios.get("common/callbackSign", params, {
      des: "获取OSS验证签名",
      sTime: new Date().getTime()
    });
  },
  //获取图片url
  async getPictureUrl(params) {
    return await axios.post("common/getPictureUrl", params, {
      des: "获取图片url",
      sTime: new Date().getTime()
    });
  },
  // 获取收币地址
  async getBindCodeList(params) {
    return await axios.get(
      "/uc/user/bindcode/list",
      { params },
      { des: "获取收币地址", sTime: new Date().getTime() }
    );
  },

  //获取收银台地址
  async getPayUrl(params) {
    return await axios.post("sysgetPayurl/list", {
      des: "获取收银台地址",
      sTime: new Date().getTime()
    });
  }
};

export default funds;



// WEBPACK FOOTER //
// ./src/api/funds.js